import axios from 'axios';
import { getBuildConfig } from "@config/buildConfig";
class Request {
    constructor() {
        const buildConfig = getBuildConfig();

        this.configuration = {
            baseUrl: buildConfig.baseUrl,
            basePath: buildConfig.basePath,
            apiTimeOverAllowance: buildConfig.apiTimeOverAllowance,
            s3TimeOverAllowance: buildConfig.s3TimeOverAllowance,
        };

        // Prevent multiple session-expired actions
        this.sessionExpiredHandled = false;
        this.sessionExpiredAction = () => {};
    }

    init({
        sessionExpiredAction = () => {},
    }) {
        this.sessionExpiredAction = sessionExpiredAction;
        this.sessionExpiredHandled = false;
    }

    post(path, params, data, isMultipart = false) {
        return this.send({
            path,
            method: 'POST',
            params,
            data,
            isMultipart,
        });
    }

    put(path, params, data) {
        return this.send({
            path,
            method: 'PUT',
            params,
            data,
        });
    }

    patch(path, params, data) {
        return this.send({
            path,
            method: 'PATCH',
            params,
            data,
        });
    }

    get(path, params, data) {
        return this.send({
            path,
            method: 'GET',
            params,
            data,
        });
    }

    delete(path, params, data) {
        return this.send({
            path,
            method: 'DELETE',
            params,
            data,
        });
    }

    send({
        path,
        method,
        params = {},
        data,
        isMultipart = false,
    }) {
        const url = `${this.configuration.baseUrl}${this.configuration.basePath}${path}`;

        const headers = isMultipart
            ? this.getMultipartHeaders()
            : this.getHeaders();

        const timeout = this.configuration.apiTimeOverAllowance;

        return new Promise((resolve, reject) => {
            axios({
                url,
                method,
                timeout,
                headers,
                params,
                data,
            })
                .then(response => {
                    resolve(response?.data?.body);
                })
                .catch(error => {
                    if (error?.response) {
                        const status = error.response.status;

                        // Session expired
                        // Do NOT reject the backend 401 message.
                        if (status === 401) {
                            this.handleSessionExpire();

                            // Important:
                            // Stop here so no alert/toast/message
                            // is triggered by the rejected promise.
                            return;
                        }

                        const message =
                            error.response.data?.meta?.message;

                        reject(message);
                        return;
                    }

                    reject();
                });
        });
    }

    getMultipartHeaders() {
        const dynamicKeys = this.configuration.token
            ? {
                Authorization: `Bearer ${this.configuration.token}`,
            }
            : {};

        return {
            'Content-Type': 'multipart/form-data',
            'x-ip-address': '184.22.161.37',
            ...dynamicKeys,
        };
    }

    getHeaders() {
        const dynamicKeys = this.configuration.token
            ? {
                Authorization: `Bearer ${this.configuration.token}`,
            }
            : {};

        return {
            'Content-Type': 'application/json',
            'x-ip-address': '184.22.161.37',
            ...dynamicKeys,
        };
    }

    setSessionToken(token) {
        this.configuration.token = token;

        // New session/token → allow session expiration handling again
        if (token) {
            this.sessionExpiredHandled = false;
        }
    }

    handleSessionExpire() {
        // Already handled
        if (this.sessionExpiredHandled) {
            return;
        }

        // Mark immediately to prevent multiple 401 responses
        // from triggering the action multiple times.
        this.sessionExpiredHandled = true;

        this.sessionExpiredAction();
    }
}

export default Request;